<template>
  <v-card-text>
    <v-select
      v-if="canUpdate"
      :label="$t('feedbackform.labels.note')"
      :items="notes"
      v-model="note"
      item-text="name"
      item-value="name">
      <template slot="selection" scope="data">
        <stars :note="data.item" :key="data.item"></stars>
      </template>
      <template slot="item" scope="data">
        <v-list-tile-content>
          <stars :note="data.item"></stars>
        </v-list-tile-content>
      </template>
    </v-select>
    <v-text-field
      v-if="canUpdate"
      v-model="content"
      name="content"
      multi-line
      required
      :label="$t('feedbackform.labels.content')"
      id="content">
    </v-text-field>
    <v-text-field
      v-model="response"
      name="response"
      multi-line
      :label="$t('feedbackform.labels.response')"
      id="response">
    </v-text-field>
  </v-card-text>
</template>

<script>
  import { mapMutations } from 'vuex'
  import Stars from '@/components/Stars'
  export default {
    components: {
      Stars
    },
    props: {
      feedback: {
        type: Object,
        required: true
      },
      notes: {
        type: Array,
        default: () => [20, 40, 60, 80, 100]
      }
    },
    data () {
      const feedback = this.feedback.modifications || this.feedback
      return {
        note: feedback.note,
        content: feedback.content,
        response: feedback.response
      }
    },
    computed: {
      canUpdate () { return this.$can('edit', 'feedbacks') }
    },
    watch: {
      note () { this.update() },
      content () { this.update() },
      response () { this.update() }
    },
    methods: {
      ...mapMutations({
        updateFeedback: 'skiliko/feedbacks/updateItem'
      }),
      update () {
        const modifications = this.canUpdate
          ? { note: this.note, content: this.content, response: this.response }
          : { response: this.response }
        this.updateFeedback({
          item: {
            id: this.feedback.id,
            modifications
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/FeedbackForm.vue